import { useState, useEffect, useRef } from "react";
import { IoIosArrowDown } from "react-icons/io";
import { MdError } from "react-icons/md";

export function DefaultSelectFilter({
  label,
  labelClass,
  id,
  name,
  value,
  onChange = () => null,
  error,
  required,
  options = [],
  classnames,
  boxheight = false,
  minimal = false
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");

  // Update selectedOption when value prop changes
  useEffect(() => {
    if (value) {
      if (minimal) {
        const findLabel = options?.find((item) => item?.value == value);
        setSelectedOption(findLabel?.label || "");
      } else {
        setSelectedOption(value);
      }
    } else if (options.length > 0) {
      setSelectedOption(options[0].label);
    }
  }, [value, options]);

  // Create a ref to track clicks outside the component
  const dropdownRef = useRef(null);

  const handleOptionClick = (option) => {
    setSelectedOption(option.label);
    if (minimal) {
      onChange(option.value)
    } else {
      onChange({ target: { name, value: option.value } });
    }
    setIsOpen(false);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false); // Close dropdown when clicked outside
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
      ref={dropdownRef}
      className={`pl-2 h-10 flex flex-row items-center relative text-sm rounded-md 
        ${boxheight ? `h-${boxheight}` : ""} ${classnames} 
        ${error ? "bg-error-100 border border-error-200" : "bg-white"}
      `}
    >
      {label && (
        <label className={`font-normal text-sm ${labelClass}`} htmlFor={id}>
          {label}
          {required && <span className="text-error-600">*</span>}
        </label>
      )}

      <div className="relative">
        <button
          type="button"
          onClick={() => setIsOpen(!isOpen)}
          className={`w-full bg-white text-left p-2 rounded-md 
            border-none focus:ring-none hover:border-none 
            ${boxheight ? `h-${boxheight}` : ""} 
            ${error ? "bg-error-100 border-error-200" : ""}
          `}
        >
          <span
            className={`flex flex-row gap-1 items-center ${!label ? "font-normal" : ""
              }`}
          >
            {selectedOption}
            <IoIosArrowDown />
          </span>
        </button>

        {isOpen && (
          <ul className="absolute right-0 z-10 mt-1 bg-white border rounded-md shadow-lg overflow-y-auto w-40 max-h-[200px]">
            {options.length ? (
              options.map((option, index) => (
                <li
                  key={index}
                  className="px-4 font-normal py-2 hover:bg-bghoverwhite cursor-pointer"
                  onClick={() => handleOptionClick(option)}
                >
                  {option.label}
                </li>
              ))
            ) : (
              <li className="px-4 font-normal py-2 hover:bg-bghoverwhite cursor-pointer">
                No Options Found!
              </li>
            )}
          </ul>
        )}

        {error && (
          <span className="flex items-center gap-1 mt-1 text-sm text-error-600">
            <MdError />
            <p>{error}</p>
          </span>
        )}
      </div>
    </div>
  );
}
